// extracted by mini-css-extract-plugin
export var actions = "_f5-d";
export var benefitCard = "_f5-a";
export var benefitIcon = "_f5-b";
export var benefitLabel = "_f5-c";
export var benefits = "_f5-9";
export var bodyText = "_f5-8";
export var closeButton = "_f5-2";
export var content = "_f5-3";
export var eyebrow = "_f5-4";
export var heading = "_f5-5";
export var image = "_f5-f";
export var imagePanel = "_f5-e";
export var modal = "_f5-0";
export var shell = "_f5-1";
export var title = "_f5-6";
export var titleOffer = "_f5-7";